import { useMutation } from "react-query"
import api from "../../client"
import { queryClient } from "../../query"
import { CreateOrderTemplatePayload, CreateOrderTemplateResponseData, UpdateOrderTemplatePayload } from "../../types/order-template"

const patchData = async (payload: CreateOrderTemplatePayload)
    : Promise<CreateOrderTemplateResponseData> => {
    try {
        const { data } = await api.post<CreateOrderTemplateResponseData>(
            `/order-templates`,
            payload
        )

        queryClient.invalidateQueries(["order-templates"], { refetchInactive: true })

        return data
    } catch ({ response: { data } }) {
        return data as CreateOrderTemplateResponseData
    }
}

export const useOrderTemplateCreate = () => {
    return useMutation((payload: UpdateOrderTemplatePayload) => {
        return patchData(payload)
    })
}
